import { render, staticRenderFns } from "./SessionDetailHeader.vue?vue&type=template&id=f8ebf370&scoped=true&"
import script from "./SessionDetailHeader.vue?vue&type=script&lang=js&"
export * from "./SessionDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ebf370",
  null
  
)

export default component.exports